import React, { useEffect, useState } from "react";
import { Person, rng, stringUtil } from "../../amorg-common";
import { AmorgMenu, AmorgMenuContent } from "../../designSystem/amorgMenu";
import { createPerson, getPersons } from "../../api/personClientApi";
import { H2 } from "../../designSystem/typography/Heading";
import { PersonEditor } from "./PersonEditor";
import { LoadingPageOverlay } from "../../designSystem/LoadingPageOverlay";
import { Modal } from "../../designSystem/Modal";


type State = {
    persons:Person[]
    inEdit:Person | null
}

export default function PersonList():JSX.Element
{
    const [loading, setLoading] = useState(null)
    const [state, setState] = React.useState<State>({
        persons:[],
        inEdit:null
    })

    useEffect(() => {
        const getData = async () => {
            await setState({
                persons: await getPersons(),
                inEdit:null
            });
            setLoading(false);
        };
        getData();
    }, [])

    async function handleUpdated()
    {
        setLoading(true);
        const persons = await getPersons();
        const inEditPerson = state.inEdit ? persons.find(x => x.id === state.inEdit.id) : null;
        setState({
            persons: persons,
            inEdit: inEditPerson
        });
        setLoading(false);
    }

    async function handleCreatePerson(){
        
        setLoading(true);
        const newPersonId = rng.getRandomId();
        const nameBase = 'Ny ansvarlig';
        const nextDescription = stringUtil.generateNextSequenceName(nameBase, state.persons.map(fa => fa.name));
        const result = await createPerson(newPersonId, "FacilityOwner", nextDescription, "", "", "" );

        if( result.isSuccess){
            const persons = await getPersons();
            const newPerson = persons.find(x => x.id === newPersonId);
            setState({
                persons,
                inEdit:newPerson
            });
        }
        setLoading(false);
    }

    function handleClickPerson(personId:string)
    {
        setState({ ...state, inEdit:state.persons.find(x => x.id === personId)});
    }

    async function handleDeleted()
    { 
        setState({
            persons:await getPersons(),
            inEdit:null
        });
        setLoading(false);
    }

    async function handleClosed(){
        setState({
            ...state,
            inEdit:null
        });
    }

    let personView: AmorgMenuContent[] = [];

    if(state.persons !== null){
        
        const sortedArray = [...state.persons]
            .sort((a, b) => a.name.localeCompare(b.name))
            .filter(person => person.type === "FacilityOwner");
            
        const peopleMenuItems:AmorgMenuContent[] = sortedArray.map( p  => {
            
            let itm:AmorgMenuContent | undefined = undefined;
            
            itm = {
                    
                    type: 'leadingContent',
                    onClick: () => handleClickPerson(p.id),
                    leadingContent: { type: 'icon', iconName: 'interface_user_user' },
                    primaryContent: { type:'textWithSubtext', text: `${p.name} ${p.role !== "" ? (" | " +  p.role) : ""}` , subtext: `${p.email !== "" ? p.email : ""} ${ (p.email !== "" && p.phone !== "") ? "|" : "" } ${p.phone !== "" ? p.phone : ""}` },
                    styleVariant: status === "alert" ? "destructive" : "default"
                    
                }
            
            return itm;
        });
        if(peopleMenuItems.length === 0){
            peopleMenuItems.push(
                {
                    type: 'leadingContent',
                    styleVariant: 'default',
                    leadingContent: { type: 'icon', iconName: 'actions_unavailable' },
                    primaryContent: { type: 'text', text: 'Ingen oprettet' }
                }
            )
        }
        
        
        personView = 
            [
                ...peopleMenuItems,
                { type: "separator" },
                {
                    onClick: () => handleCreatePerson(),
                    type: 'leadingContent',
                    leadingContent: { type: 'icon', iconName: 'actions_plus' },
                    primaryContent: { type: 'text', text: 'Opret ansvarlig' },
                    styleVariant: 'emphasized'
                }
            ];
    }
    

    return (
        <>
        <LoadingPageOverlay loading={loading} />
        {state.persons &&
            <>
            <H2>
                Facilitetsansvarlige
            </H2>
            
            {/* TODO: Card styling */}
            <AmorgMenu content={personView} />

            <Modal 
                title={"Rediger ansvarlig"}
                content={
                    <PersonEditor
                        person={state.inEdit}
                        onDeleted={handleDeleted}
                        onUpdated={handleUpdated}
                        onClose={handleClosed}
                    />
                }
                showModal={state.inEdit !== null}
                onCancel={handleClosed} />
            
            </>
            }
        </>
    );
 }